const tinyMCE = {
  path: 'https://cdn-acare.e-personam.com/ext/tinymce/v6.8.3.25/tinymce.min.js',
  name: 'textarea-js',
  type: 'js',
};

export const componentsAsync = [
  {
    key: 'popup-signature-svg-container',
    path: import.meta.glob('./components/adv_components/popupSignatureSvgContainer.vue'),
  },
  {
    dependencies: [tinyMCE],
    key: 'tab-panel-container',
    path: import.meta.glob('./components/adv_components/tabPanelContainer/tabPanelContainer.vue'),
  },
  {
    key: 'outpatient-records-container',
    path: import.meta.glob('./components/adv_components/outpatient/outpatientRecordsContainer.vue'),
  },
  {
    key: 'how-print-parameter',
    path: import.meta.glob('./components/howPrintParameter/howPrintParameter.vue'),
  },
  {
    key: 'dashboard',
    path: import.meta.glob('./components/dashboard/dashboard.vue'),
  },
  {
    dependencies: [tinyMCE],
    key: 'discharge-letter',
    path: import.meta.glob('./components/discharge_letter/own_model/discharge_letter.vue'),
  },
  {
    key: 'modal-copy-guest-drug',
    path: import.meta.glob('./components/guestDrugs/modalCopyGuestDrug.vue'),
  },
  {
    dependencies: [tinyMCE],
    key: 'vtextarea',
    path: import.meta.glob('./components/vtextarea/vtextarea.vue'),
  },
  {
    key: 'linked-devices',
    path: import.meta.glob('./components/linked_devices/linked_devices.vue'),
  },
  {
    key: 'send-mail-to-relatives',
    path: import.meta.glob('./components/pais/sendMailToRelatives.vue'),
  },
  {
    dependencies: [tinyMCE],
    key: 'guests-container',
    path: import.meta.glob('./components/adv_components/guestsContainer.vue'),
  },
  {
    key: 'sgdt-guests-container',
    path: import.meta.glob('./components/adv_components/sgdt/sgdtGuestsContainer.vue'),
  },
  {
    key: 'siss-authorisation-container',
    path: import.meta.glob('./components/adv_components/siss/sissAuthorisationContainer.vue'),
  },
  {
    key: 'sgdt-valutations-container',
    path: import.meta.glob('./components/adv_components/sgdt/sgdtValutationsContainer.vue'),
  },
  {
    dependencies: [tinyMCE],
    key: 'cot-discharge-notifications-container',
    path: import.meta.glob('./components/adv_components/cotDischargeNotificationsContainer.vue'),
  },
  {
    dependencies: [tinyMCE],
    key: 'cot-task-container',
    path: import.meta.glob('./components/adv_components/diaries/cotTaskContainer.vue'),
  },
  {
    key: 'slopes-page',
    path: import.meta.glob('./components/adv_components/pages/slopesPage.vue'),
  },
  {
    key: 'loader-container',
    path: import.meta.glob('./components/adv_components/loaderContainer.vue'),
  },
  {
    key: 'toast-container',
    path: import.meta.glob('./components/adv_components/toastContainer.vue'),
  },
  {
    key: 'popup-confirm-container',
    path: import.meta.glob('./components/adv_components/popupConfirmContainer.vue'),
  },
  {
    key: 'measurements-wards-rounds-container',
    path: import.meta.glob('./components/adv_components/measurementsWardsRoundsContainer.vue'),
  },
  {
    key: 'preference-structure-page',
    path: import.meta.glob('./components/adv_components/pages/preferenceStructurePage.vue'),
  },
  {
    key: 'login-container',
    path: import.meta.glob('./components/adv_components/loginContainer.vue'),
  },
  {
    key: 'navigation-container',
    path: import.meta.glob('./components/adv_components/navigationContainer.vue'),
  },
  {
    key: 'navbar',
    path: import.meta.glob('./components/adv_components/navbar.vue'),
  },
  {
    key: 'domestic-time-slot-creator',
    path: import.meta.glob('./components/domestic_timeslot/domestic_timeslot_creator.vue'),
  },
  {
    key: 'domestic-date-slot-creator',
    path: import.meta.glob('./components/domestic_timeslot/domestic_dateslot_creator.vue'),
  },
  {
    key: 'suspensions-container',
    path: import.meta.glob('./components/guestDrugsSuspensions/suspensionsContainer.vue'),
  },
  {
    key: 'cot-logs-container',
    path: import.meta.glob('./components/cot/cotLogsContainer.vue'),
  },
  {
    key: 'cot-modal-accept',
    path: import.meta.glob('./components/cots/cotModalAccept.vue'),
  },
  {
    key: 'cot-beds-manager-container',
    path: import.meta.glob('./components/cots/bedsManager/cotBedsManagerContainer.vue'),
  },
  {
    key: 'siat-modal-piani',
    path: import.meta.glob('./components/siat/siatModalPiani.vue'),
  },
  {
    key: 'paghe-dolce-modal',
    path: import.meta.glob('./components/pagheDolce/pagheDolceModal.vue'),
  },
  {
    key: 'profile-therapies-container',
    path: import.meta.glob('./components/profileTherapies/profileTherapiesContainer.vue'),
  },
  {
    key: 'profile-therapies-modal',
    path: import.meta.glob('./components/profileTherapies/profileTherapiesModal.vue'),
  },
  {
    key: 'guest-deseases-container',
    path: import.meta.glob('./components/guestDeseases/guestDeseasesContainer.vue'),
  },
  {
    key: 'guest-needs-container',
    path: import.meta.glob('./components/guestNeeds/guestNeedsContainer.vue'),
  },
  {
    key: 'guest-icfs-container',
    path: import.meta.glob('./components/guestIcfs/guestIcfsContainer.vue'),
  },
  {
    dependencies: [tinyMCE],
    key: 'decode-edit',
    path: import.meta.glob('./components/form/decodeEdit.vue'),
  },
  {
    dependencies: [tinyMCE],
    key: 'custom-consent-text-creator',
    path: import.meta.glob('./components/custom_consents/customConsentTextCreator.vue'),
  },
  {
    dependencies: [tinyMCE],
    key: 'diaries-container',
    path: import.meta.glob('./components/adv_components/diaries/diariesContainer.vue'),
  },
  {
    dependencies: [tinyMCE],
    key: 'cot-diary-list',
    path: import.meta.glob('./components/adv_components/diaries/cotDiaryList.vue'),
  },
  {
    key: 'riallinamento-dati-modal',
    path: import.meta.glob('./components/sgdt/riallinamentoDatiModal.vue'),
  },
  {
    key: 'users-on-same-resource',
    path: import.meta.glob('./components/usersOnSameResource/index.vue'),
  },
  {
    key: 'guest-drugs-allergies',
    path: import.meta.glob('./components/guestDrugs/guestDrugsAllergies.vue'),
  },
  {
    key: 'guest-drugs-allergies-warning',
    path: import.meta.glob('./components/guestDrugs/guestDrugsAllergiesWarning.vue'),
  },
  {
    key: 'guest-drugs-interactions-warning',
    path: import.meta.glob('./components/guestDrugs/guestDrugsInteractionsWarning.vue'),
  },
  {
    dependencies: [tinyMCE],
    key: 'autoform',
    path: import.meta.glob('./components/autoform/autoform.vue'),
  },
  {
    dependencies: [tinyMCE],
    key: 'auto-form-wrapper',
    path: import.meta.glob('./components/adv_components/autoFormWrapper.vue'),
  },
  {
    dependencies: [tinyMCE],
    key: 'consent-templates',
    path: import.meta.glob('./components/consentTemplates/consentTemplates.vue'),
  },
  {
    dependencies: [tinyMCE],
    key: 'custom-template',
    path: import.meta.glob('./components/customTemplate/customTemplate.vue'),
  },
  {
    key: 'tab-panel-container',
    path: import.meta.glob('./components/adv_components/tabPanelContainer/tabPanelContainer.vue'),
  },
  {
    key: 'guest-exams-request-container',
    path: import.meta.glob('./components/adv_components/guestExamsRequests/guestExamsRequestContainer.vue'),
  },
  {
    key: 'guest-exams-requests-container',
    path: import.meta.glob('./components/adv_components/guestExamsRequests/guestExamsRequestsContainer.vue'),
  },
  {
    dependencies: [tinyMCE],
    key: 'diaries-table',
    path: import.meta.glob('./components/diaries/diariesTable.vue'),
  },
  {
    key: 'sgdt-reevaluation-reason-form',
    path: import.meta.glob('./components/adv_components/sgdt/sgdtReevaluationReasonForm.vue'),
  },
  {
    key: 'foglio-unico-terapia',
    path: import.meta.glob('./components/foglioUnicoTerapia/foglioUnicoTerapia.vue'),
  },
  {
    key: 'select-profiles',
    path: import.meta.glob('./components/domestics/selectProfiles.vue'),
  },
  {
    key: 'dispensing-unit-list-popup',
    path: import.meta.glob('./components/dispensingUnit/dispensingUnitListPopup.vue'),
  },
  {
    key: 'guest-exam-result',
    path: import.meta.glob('./components/guestExamResults/guestExamResult.vue'),
  },
  {
    key: 'update-cod-drg-effettivo',
    path: import.meta.glob('./components/updateCodDrgEffettivo/updateCodDrgEffettivo.vue'),
  },
  {
    key: 'valutation-alert',
    path: import.meta.glob('./components/guestValutations/valutationAlert.vue'),
  },
  {
    key: 'guest-drugs-coumadin-list',
    path: import.meta.glob('./components/guestDrugsCoumadin/guestDrugsCoumadinList.vue'),
  },
  {
    key: 'floating-actions-buttons-container',
    path: import.meta.glob('./components/floatingActionsButtonsContainer.vue'),
  },
  {
    key: 'planning-maps-container',
    path: import.meta.glob('./components/planningMaps/planningMapsContainer.vue'),
  },
  {
    key: 'diary-event-modal',
    path: import.meta.glob('./components/diaries/diaryEventModal.vue'),
  },
  {
    key: 'consent',
    path: import.meta.glob('./components/consents/consent.vue'),
  },
  {
    key: 'contact-center',
    path: import.meta.glob('./components/contactCenter/contactCenter.vue'),
  },
  {
    key: 'digital-signature-modal',
    path: import.meta.glob('./components/digitalSignature/digitalSignatureModal.vue'),
  },
  {
    key: 'telemonitoring-device-page',
    path: import.meta.glob('./components/telemonitoringDevice/telemonitoringDevicePage.vue'),
  },
  {
    key: 'flusso-cad-container',
    path: import.meta.glob('./components/flussoCad/flussoCadContainer.vue'),
  },
  {
    key: 'load-documents-modal',
    path: import.meta.glob('./components/adv_components/loadDocumentsModal/loadDocumentsModal.vue'),
  },
  {
    key: 'guest-exemption-container',
    path: import.meta.glob('./components/guestExemption/guestExemptionContainer.vue'),
  },
  {
    dependencies: [tinyMCE],
    key: 'dashboard-container',
    path: import.meta.glob('./components/adv_components/dashboard/dashboardContainer.vue'),
  },
  {
    key: 'clinical-profile-container',
    path: import.meta.glob('./components/clinicalProfile/clinicalProfileContainer.vue'),
  },
  {
    key: 'absences-list',
    path: import.meta.glob('./components/absencesList/absencesList.vue'),
  },
  {
    key: 'bom-list',
    path: import.meta.glob('./components/bomList/bomList.vue'),
  },
  {
    key: 'tags',
    path: import.meta.glob('./components/tags/tags.vue'),
  },
  {
    key: 'print-listener',
    path: import.meta.glob('./components/printListener/printListener.vue'),
  },
  {
    key: 'print-template-container',
    path: import.meta.glob('./components/printTemplateContainer/printTemplateContainer.vue'),
  },
  {
    key: 'alert-box-container',
    path: import.meta.glob('./components/adv_components/alertBoxContainer.vue'),
  },
  {
    key: 'cot-settings-container',
    path: import.meta.glob('./components/setting/cotSettingsContainer.vue'),
  },
  {
    key: 'modal-impo-mail',
    path: import.meta.glob('./components/mail/modalImpoMail.vue'),
  },
  {
    key: 'modal-sub-activities',
    path: import.meta.glob('./components/guestActivity/modalSubActivities.vue'),
  },
  {
    key: 'modal-import-activities',
    path: import.meta.glob('./components/domestics/modalImportActivities.vue'),
  },
  {
    key: 'modal-referent-form',
    path: import.meta.glob('./components/guestReferents/modalReferentForm.vue'),
  },
  {
    key: 'modal-cure-intermedie',
    path: import.meta.glob('./components/modalCureIntermedie/modalCureIntermedie.vue'),
  },
  {
    key: 'pdf-to-canvas',
    path: import.meta.glob('./components/pdfToCanvas/pdfToCanvas.vue'),
  },
  {
    key: 'modal-users-online',
    path: import.meta.glob('./components/modalUsersOnline/modalUsersOnline.vue'),
  },
  {
    key: 'guest-activity-results',
    path: import.meta.glob('./components/guestActivityResults/guestActivityResults.vue'),
  },
  {
    key: 'flusso-cot',
    path: import.meta.glob('./components/flussoCot/flussoCot.vue'),
  },
  {
    key: 'fse-documents',
    path: import.meta.glob('./components/fseDocuments/fseDocuments.vue'),
  },
  {
    key: 'printlink',
    path: import.meta.glob('./components/printlink.vue'),
  },
  {
    key: 'change_dashboard',
    path: import.meta.glob('./components/dashboard/changeDashboard.vue'),
  },
  {
    key: 'report-print-row',
    path: import.meta.glob('./components/menu_reports/reportPrintRow.vue'),
  },
  {
    key: 'print-labels',
    path: import.meta.glob('./components/guestPeriodDataSet/labels/printLabels.vue'),
  },
  {
    key: 'print-folder-zebra',
    path: import.meta.glob('./components/guestPeriodDataSet/printFolderZebra.vue'),
  },
  {
    key: 'guests-sms-modal',
    path: import.meta.glob('./components/smsSender/guestSmsModal.vue'),
  },
  {
    key: 'traveled-km-modal',
    path: import.meta.glob('./components/users/traveledKmModal.vue'),
  },
  {
    key: 'fa-icon',
    path: import.meta.glob('./components/faIcon.vue'),
  },
  {
    key: 'webinar-calendar',
    path: import.meta.glob('./components/webinar/webinarCalendar.vue'),
  },
  {
    key: 'v-menu-icon',
    path: import.meta.glob('./components/vMenuIcon.vue'),
  },
  {
    key: 'bu-pacchetto-areas', //todo missing lazy load
    path: import.meta.glob('./components/activity/buPacchettoAreas.vue'),
  },
  {
    key: 'replacements',
    path: import.meta.glob('./components/domestics/replacements.vue'),
  },
  {
    key: 'tabs-discharge',
    path: import.meta.glob('./components/discharge_letter/tabs/tabs.vue'),
  },
  {
    dependencies: [tinyMCE],
    key: 'fse-discharge',
    path: import.meta.glob('./components/discharge_letter/fse_discharge/fse_discharge.vue'),
  },
  {
    key: 'month-year-filter',
    path: import.meta.glob('./components/print/filters/monthYearFilter.vue'),
  },
  {
    key: 'modal-ricetta',
    path: import.meta.glob('./components/modalRicetta/modalRicetta.vue'),
  },
  {
    key: 'close-valutation',
    path: import.meta.glob('./components/pais/closeValutation.vue'),
  },
  {
    key: 'edit-month-locks',
    path: import.meta.glob('./components/domestics/editMonthLocks.vue'),
  },
  {
    key: 'relatives-visits-container',
    path: import.meta.glob('./components/relativesVisits/relativesVisitsContainer.vue'),
  },
  {
    key: 'agenda-search',
    path: import.meta.glob('./components/domestics/agendaSearch.vue'),
  },
  {
    key: 'agenda-list',
    path: import.meta.glob('./components/domestics/agendaList.vue'),
  },
  {
    key: 'smartlea-modal',
    path: import.meta.glob('./components/smartlea/smartleaModal.vue'),
  },
  {
    key: 'andiamo-modal',
    path: import.meta.glob('./components/andiamo/andiamoModal.vue'),
  },
  {
    key: 'guest-anagraphic-alignment',
    path: import.meta.glob('./components/guest/guestAnagraphicAlignment.vue'),
  },
  {
    key: 'guest-referents',
    path: import.meta.glob('./components/guestReferents/guestReferents.vue'),
  },
  {
    dependencies: [tinyMCE],
    key: 'fse-business-unit',
    path: import.meta.glob('./components/discharge_letter/business_unit/fseBusinessUnit.vue'),
  },
  {
    key: 'gdprconsent',
    path: import.meta.glob('./components/gdpr/gdprconsent.vue'),
  },
  {
    key: 'alert-equipe',
    path: import.meta.glob('./components/domestics/alertEquipe.vue'),
  },
  {
    key: 'kit',
    path: import.meta.glob('./components/kit/kit.vue'),
  },
  {
    key: 'guest-presences-summary',
    path: import.meta.glob('./components/guestPresences/guestPresencesSummary.vue'),
  },
  {
    key: 'presence-summary',
    path: import.meta.glob('./components/guestPresences/presenceSummary.vue'),
  },
  {
    key: 'replacements-equipe',
    path: import.meta.glob('./components/domestics/replacements_equipe.vue'),
  },
  {
    key: 'equipe-history',
    path: import.meta.glob('./components/domestics/equipe_history.vue'),
  },
  {
    key: 'fe1-analitica-exports-index',
    path: import.meta.glob('./components/fe1AnaliticaExports/fe1AnaliticaExportsIndex.vue'),
  },
];
